<script>

import IkDataTable from '@/plugins/EntityFrameWork/IkDataTable.vue'
import Progress from '@/model/dataLayer/api/Vip/Progress'

export default {
  name: 'AllProgress',
  components: {
    IkDataTable
  },
  data () {
    return {
      model: Progress,
      btnLoading: false,
      showEditDialog: false,
      blInfo: {}
    }
  },
  async mounted () {
    await this.reload()
  },
  methods: {
    async reload () {

    }
  }
}
</script>

<template>
  <v-container>
    <ik-data-table
      ref="table"
      :model="model"
      :use-default-action="false"
      entity-name="AllProgress"
      icon="mdi-cash-usd"
    >
      <template #item.progressLinear="{item}">
        <v-progress-linear
          :value="(item.progress / item.awardMax) * 100"
          color="green"
          height="20"
        >
          <strong>{{ Math.ceil((item.progress / item.awardMax) * 100) }}%</strong>
        </v-progress-linear>
      </template>
    </ik-data-table>
  </v-container>
</template>

<style scoped>

</style>
